import { make } from 'vuex-pathify';
import makeTableCommonActions from '../../utils/vuexModuleConstructor/vuexTableCommonActionsMaker';
import makeTableCommonGetters from '../../utils/vuexModuleConstructor/vuexTableCommonGettersMaker';
import makeTableCommonState from '../../utils/vuexModuleConstructor/vuexTableCommonStateMaker';
import createRecords from 'src/utils/entityOperations/createRecords';
const remoteEntityName = 'meta.ui_menus';
const state = Object.assign({}, makeTableCommonState());
const getters = Object.assign(Object.assign({}, makeTableCommonGetters({ remoteEntityName })), { pageTitle: () => 'UI menus', controlledActions: () => {
        return {
            create: -1,
            fetch: 0,
            update: 0,
            delete: -1,
            downloadList: 0,
            uploadList: -1
        };
    }, row: (state, getters, rootState) => {
        const rowIsDefault = (rowProps) => rowProps.rowData.id === 0;
        return {
            disableEditing: rowIsDefault,
            classes: (rowProps) => {
                if (rowProps.tableData && !rowProps.tableData[1])
                    return undefined; // i.e., if only length 0, then no class is added
                return rowProps.rowData.id === 0 ? ['bg-grey-5'] : undefined;
            }
        };
    }, columns: (state, getters, rootState) => {
        const makeMenuCurrent = (cellProps, ctx, e) => {
            const menuId = Number(cellProps.row.id || 0); // '0' is default menu that is hardcoded in code and passed as prop to LdmTemplate
            ctx.$store.commit('meta.ui_menus/SET_CURRENT', menuId);
            if (menuId !== 0)
                createRecords('meta.ui_menus_user_defaults', [{ user_id: rootState.authorizedUser.userObj.id, app_id: rootState.authorizedUser.currentAppObject.id, menu_id: menuId }]);
        };
        const disableDelete = (cellProps) => Number(cellProps.row.id) === 0;
        return [
            { name: 'del', field: '', isDisabled: disableDelete, cellContentIsHidden: disableDelete },
            { name: 'btn_put_menu_in_slot', field: '', tooltipContent: 'View this menu', icon: 'mdi-arrow-collapse-left', isButton: true, buttonClickHandler: makeMenuCurrent },
            { name: 'id', field: 'id', label: 'ID' },
            { name: 'name', field: 'name', label: 'Name', inlineEdit: true },
            { name: 'description', field: 'description', label: 'Description', inlineEdit: true },
            { name: 'app_id', field: 'app_id', label: 'App', references: ((rootState['authorizedUser'].availableTenantsAndApps || {}).available_apps || []).map((r) => r.app) },
            { name: 'org_id', field: 'org_id', label: 'Org', references: (rootState['authorizedUser'].availableOrgs || {}), editable: true },
            { name: 'tenant_id', field: 'tenant_id', label: 'Tenant', references: ((rootState['authorizedUser'].availableTenantsAndApps || {}).available_tenants || []).map((r) => r.org), editable: true },
            { name: 'user_id', field: 'user_id', label: 'User', references: [{ id: 0, name: 'All current and future users' }, ...rootState['users.users'].list], editable: true },
            { name: 'menu_object', style: 'width: 100px', field: 'menu_object', label: 'Menu object', isCode: true, maxLines: 1, editable: true }
        ];
    } });
const mutations = make.mutations(state);
const namespaced = true;
const actions = Object.assign({}, makeTableCommonActions());
export default { state, actions, mutations, getters, namespaced };
